"use strict";

require("core-js/modules/es.array.reduce.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT = exports.IS_DISABLED_OPTIONS = exports.INITIAL_VALUES = exports.FIELDS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var TRANSLATION = {
  registeredPwd: 'Are you a registerd Person with Disability?',
  yes: 'Yes',
  no: 'No',
  pwdId: 'PWD ID',
  pwdNoteHeader: 'Person with Disability',
  pwdNote: "Pursuant to R.A. No. 7277 as amended by R.A. 10754,\n    An Act Expanding the benefits and Privileges of Person with Disability (PWD),\n    PWDs must input their PWD Card Number to be eligible for a 20% discount on the base fare for domestic flights.\n    PWDs must present their PWD Card together with any VALID ID at the check-in counter for verification.\n    Failure to do so may result in penalties of PHP 1,500 plus the fare difference or denial of boarding.",
  requiredError: 'This field is required.',
  maxLengthError: 'Max allowed charater is {max}.'
};
exports.TRANSLATION = TRANSLATION;
var IS_DISABLED_OPTIONS = [{
  label: TRANSLATION.yes,
  value: 'true'
}, {
  label: TRANSLATION.no,
  value: 'false'
}];
exports.IS_DISABLED_OPTIONS = IS_DISABLED_OPTIONS;
var FIELDS = {
  isPwd: {
    label: TRANSLATION.registeredPwd,
    name: 'isPwd'
  },
  pwdId: {
    label: TRANSLATION.pwdId,
    name: 'pwdId'
  }
};
exports.FIELDS = FIELDS;

var INITIAL_VALUES = _objectSpread({}, Object.keys(FIELDS).reduce(function (acc, curr) {
  acc[curr] = '';
  return acc;
}, {}));

exports.INITIAL_VALUES = INITIAL_VALUES;
var TEXT = {
  COLOR: 'secondary',
  TYPE: 'sub'
};
exports.TEXT = TEXT;